import { DriveStep } from 'driver.js'
import i18n from 'i18next'

import {
  USER_LEVEL,
  UserLevel,
} from '../../../../components/Settings/definitions'

const TITLE_DRIVER = i18n.t('New training')

const getAnomalyCustomDriverSteps = (userLevel: UserLevel): DriveStep[] => [
  {
    element: '#divBackboneId',
    popover: {
      title: TITLE_DRIVER,
      description: i18n.t('Select one or more backbones.'),
      side: 'bottom',
      align: 'start',
    },
  },
  {
    element: '#fp16SwitchId',
    popover: {
      title: TITLE_DRIVER,
      description: i18n.t(
        'Enable the FP16 model precision for faster training and inference. The performance might be slightly lower.'
      ),
      side: 'bottom',
      align: 'start',
    },
  },
  {
    element: '#divResolutionId',
    popover: {
      title: TITLE_DRIVER,
      description:
        userLevel === USER_LEVEL.expert
          ? i18n.t('Select the resolution.')
          : i18n.t(
              'The resolution is enabled only for expert users. The user level can be changed in the settings.'
            ),
      side: 'bottom',
      align: 'start',
    },
  },
  {
    element: '#divAnomalyStrategyId',
    popover: {
      title: TITLE_DRIVER,
      description: i18n.t('Select the anomaly strategy.'),
      side: 'bottom',
      align: 'start',
    },
  },
]

export default getAnomalyCustomDriverSteps
